import React, { useEffect } from "react";
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import ProducerCodeDashboard from "./views/ProducerCodeDashboard";
import ProducerCodeModule from "./views/ProducerCodeModule";
import ProducerCodeNotifications from "./views/ProducerCodeNotifications";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "./permissions";

const BASE = "/carrieragreementmgmt/producercodeconfig";

type NavState = {
  view?: string;
  intent?: string;
  action?: string;
  moduleName?: string;
  producerCodeId?: string | number;
  carrierProducerCodeId?: string | number;
  masterCarrierId?: string | number;
};

const ProducerCodeIndex: React.FC = () => {
  const history = useHistory();
  const location = useLocation<NavState | undefined>();

  const userPermissions = useRecoilValue(permissionsSelector);

  const canViewNotifications = userPermissions.includes(
    PERMISSIONS.fieldpermission_carrier_notifications
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryView = (params.get("view") || "").toLowerCase();

    let targetPath: string | null = null;

    if (
      queryView === "table" ||
      queryView === "notifications" ||
      queryView === "dashboard"
    ) {
      targetPath = `${BASE}${queryView === "dashboard" ? "" : `/${queryView}`}`;
    } else {
      const navState = (location.state || {}) as NavState;

      const goToTable = Boolean(
        navState.view === "table" ||
          navState.intent === "table" ||
          navState.action === "CarrierProducerCode" ||
          navState.moduleName === "Producer Code" ||
          navState.producerCodeId ||
          navState.carrierProducerCodeId ||
          navState.masterCarrierId
      );

      const isAtBasePath = location.pathname === BASE;

      if (isAtBasePath && goToTable) {
        targetPath = `${BASE}/table`;
      }
    }

    if (targetPath && location.pathname !== targetPath) {
      history.replace(targetPath, location.state);
    }
  }, [history, location.pathname, location.search, location.state]);

  return (
    <Switch>
      <Route exact path={BASE}>
        <ProducerCodeDashboard
          onOpenModule={() => history.push(`${BASE}/table`)}
          onOpenNotifications={() => history.push(`${BASE}/notifications`)}
        />
      </Route>

      <Route path={`${BASE}/table`} component={ProducerCodeModule} />
      <Route
        path={`${BASE}/notifications`}
        render={() =>
          canViewNotifications ? (
            <ProducerCodeNotifications />
          ) : (
            <Redirect to={BASE} />
          )
        }
      />

      <Redirect to={BASE} />
    </Switch>
  );
};

export default ProducerCodeIndex;
